import React, { useState, useEffect } from 'react';
import { useNotifications } from './NotificationProvider';
import { ToastStack } from './Toast';
import { ErrorModal } from './ErrorModal';

/**
 * NotificationRenderer
 * 
 * Componente unificado que renderiza automaticamente:
 * - ToastStack para todas as notificações (incluindo erros não sticky)
 * - ErrorModal para erros sticky (críticos)
 * 
 * Uso: Renderizar uma única vez no App.tsx ao invés de ToastStack
 */
export function NotificationRenderer() {
  const { items, dismiss } = useNotifications();
  const [modalError, setModalError] = useState<typeof items[0] | null>(null);

  // Detectar erros sticky e abrir modal automaticamente
  useEffect(() => {
    const stickyError = items.find(
      (item) => item.type === 'error' && item.sticky === true
    );

    if (stickyError && (!modalError || modalError.id !== stickyError.id)) {
      setModalError(stickyError);
    } else if (!stickyError && modalError) {
      setModalError(null);
    }
  }, [items, modalError]);

  const handleCloseModal = () => {
    if (modalError) {
      dismiss(modalError.id);
      setModalError(null);
    }
  };

  return (
    <>
      {/* Toast Stack para todas as notificações */}
      <ToastStack />

      {/* Error Modal automático para erros sticky */}
      {modalError && (
        <ErrorModal
          open={true}
          title={modalError.title || 'Erro'}
          message={modalError.message}
          onClose={handleCloseModal}
          actions={modalError.actions}
        />
      )}
    </>
  );
}

